export const SSO_API_BASE_URL = 'https://sso-worker.khanhthinh-45a4.workers.dev'

export const AUTH_ENDPOINTS = {
  register: '/v1/auth/register',
  login: '/v1/auth/login',
  logout: '/v1/auth/logout',
  refresh: '/v1/auth/refresh',
  me: '/v1/auth/me',
  verifyEmail: '/v1/auth/verify-email',
  resendVerification: '/v1/auth/resend-verification',
  forgotPassword: '/v1/auth/forgot-password',
  resetPassword: '/v1/auth/reset-password',
  updateProfile: '/v1/auth/profile',
  google: '/v1/auth/google',
  totpVerify: '/v1/auth/totp/verify',
  createCode: '/v1/auth/create-code',
  exchangeCode: '/v1/auth/exchange-code',
  findUser: '/v1/auth/find-user',
  getUsers: '/v1/auth/users',
} as const
